/**
 * Construye las filas visibles del tooltip del detalle diario.
 *
 * @param {object} v - Modelo de presentación calculado por PanelRuntime.
 * @returns {Array<object>} Métricas disponibles con etiqueta, valor y unidad.
 */
export function buildDetailTooltipMetrics(v) {
  return [{
  show: v.hasActivity,
  label: 'Act.',
  value: v.vA,
  unit: '%',
  color: 'oklch(0.78 0.14 160)'
}, {
  show: v.hasRate,
  label: 'Tasa',
  value: v.vT,
  unit: 'kg/min',
  color: 'oklch(0.72 0.14 55)'
}, {
  show: v.hasPpa,
  label: 'PPA',
  value: v.vP,
  unit: 'pellets',
  color: 'oklch(0.68 0.2 25)'
}, {
  show: v.hasOxygen,
  label: 'O₂',
  value: v.vO,
  unit: v.det?.oxygenUnit || '%',
  color: 'oklch(0.78 0.11 220)'
}, {
  show: v.hasTemperature,
  label: 'Temp.',
  value: v.vTe,
  unit: '°C',
  color: 'oklch(0.74 0.13 340)'
}, {
  show: v.hasCurrent,
  label: 'Corr.',
  value: v.vC,
  unit: 'cm/s',
  color: 'oklch(0.72 0.14 295)'
}, {
  show: v.hasDirection,
  label: 'Dir.',
  value: v.vCd,
  unit: '',
  color: 'oklch(0.72 0.14 295)'
}, {
  show: v.hasDepth,
  label: 'Prof.',
  value: v.vD,
  unit: 'm',
  color: 'oklch(0.72 0.12 210)'
}].filter(metric => metric.show);
}
